module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/PANS-LABYRINTH.5d35804.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/PANS-LABYRINTH.jpg
// module id = dhRB
// module chunks = 0